import { useState, useEffect } from 'react';
import { Modal, Button, FormControl } from 'react-bootstrap';
import { useFormik } from 'formik';
import { addParticipantValidate } from '@/utils/validation';
import { decrypt } from '@/utils/crypto';
import { NavLink } from 'react-router-dom';
import { constant, modal, table } from '@/utils/constant';
import { emitAddParticipant } from '@/utils/socketHelpers';
import { toast } from "react-toastify";

function WelcomeParticipants({ session, id, socket }) {
	const [show, setShowModel] = useState(false);
	const [isDisabled, setIsDisabled] = useState(false);
	const [errorMsg, setErrorMsg] = useState('');
	const [results, setResults] = useState([]);
	const [isSearchClick, setIsserchClick] = useState(false);
	const [isTrue, setIsTrue] = useState(false);
	const [isSearch, setIsSearch] = useState(0);
	const [options, setOptions] = useState([]);
	const [options1, setOptions1] = useState([]);

	useEffect(() => {
		const hasOpened = session?.reset_game_count > 0 || session?.game_completed_at || sessionStorage.getItem("modalOpened");
		const isSetParticipant = sessionStorage.getItem('setParticipant');
		const isNotEmpty = Object.keys(session).length > 0;
		if (!hasOpened && isNotEmpty && !isSetParticipant) {
			setShowModel(!session.is_open_game_link);
			sessionStorage.setItem("modalOpened", true);
		}
	}, [session, session.is_open_game_link]);

	const formik = useFormik({
		initialValues: {
			firstName: '',
			lastName: '',
		},
		validationSchema: addParticipantValidate,
		onSubmit: async values => {
			setErrorMsg('');
			setIsTrue(false);
			setIsDisabled(true);
			const addParticipantsData = {
				session_id: Number(decrypt(id)),
				first_name: values.firstName,
				last_name: values.lastName,
				isSearchClick: isSearchClick,
			};
			try {
				const data = await emitAddParticipant(socket, addParticipantsData);
				sessionStorage.setItem('setParticipant', true)
				if (data?.data?.length > 0) {
					socket.emit('store-session-welcome-model-first-last-name', {
						session_id: Number(decrypt(id)),
						id: data.data[0].id,
						first_name: values.firstName,
						last_name: values.lastName
					});
				}
				if (data.status || (data?.data?.length > 0)) {
					toast(
						<>
							<b>Success!</b> You're registered. Please wait for your team and role assignment.
						</>,
						{
							position: "top-center",
							className: "foo-bar",
						}
					);
				}
				if (data?.error) {
					setIsTrue(Boolean(data?.data?.isSessionFull));
					setErrorMsg(data?.error);
					setIsDisabled(false);
				} else if (!data.data) {
					setIsDisabled(false);
					setShowModel(false);
					sessionStorage.removeItem('modalOpened');
				} else {
					setShowModel(false);
					sessionStorage.removeItem('modalOpened');
				}
			} catch (error) {
				setIsDisabled(false);
				setErrorMsg('Something went wrong. Please try again.');
			}
		},
	});

	const handleSearchChange = async event => {
		setIsserchClick(false);
		const { name, value } = event.target;
		formik.handleChange(event);
		if ((name === 'firstName' || name === 'lastName') && value.length >= 2) {
			setIsSearch(name === 'firstName' ? 1 : 2);
			socket.emit('search-session-welcome-model-first-last-name', {
				session_id: Number(decrypt(id)),
				first_name: value,
				last_name: value
			});
		} else {
			setResults([]);
		}
	};

	useEffect(() => {
		const handleResponse = (response) => {
			setResults(response || []);
		};

		socket.on('res-search-session-welcome-model-first-last-name', handleResponse);

		return () => {
			socket.off('res-search-session-welcome-model-first-last-name', handleResponse);
		};
	}, [socket, setResults]);

	useEffect(() => {
		if (isSearch === 1) {
			setOptions(
				results && results?.map(user => ({
					value: user.id,
					label: `${user.first_name} ${user.last_name}`,
					first_name: user.first_name,
					last_name: user.last_name,
				}))
			);
		} else if (isSearch === 2) {
			setOptions1(
				results && results?.map(user => ({
					value: user.id,
					label: `${user.first_name} ${user.last_name}`,
					first_name: user.first_name,
					last_name: user.last_name,
				}))
			);
		}
	}, [isSearch, results]);

	return (
		<>
			<Modal
				show={show}
				size='md'
				centered
			>
				<Modal.Header
					className='bg-secondary'
				>
					<Modal.Title className='ps-sm-6'>
						{modal?.addWelcomeParticipantModalTitle}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body className='py-10'>
					<p className='text-center'>
						{modal?.addWelcomeParticipantText}
						<b> {session?.name}</b>
					</p>
					<p className='mb-5 text-center'>
						{modal?.addWelcomeParticipantText1}
					</p>
					<form
						className='mx-auto form'
						onSubmit={formik.handleSubmit}
					>
						<div>
							<label
								className='form-label'
								htmlFor='firstName'
							>
								{constant?.firstName}
							</label>
							<FormControl
								value={formik.values.firstName}
								onChange={handleSearchChange}
								name='firstName'
								placeholder=''
								autoComplete='off'
							/>
							{options.length > 0 && (
								<ul className='w-full bg-light p-3 list-unstyled'>
									{options.map((option, index) => (
										<li
											key={index}
											className='cursor-pointer'
											onClick={() => {
												formik.setFieldValue('firstName', option.first_name);
												formik.setFieldValue('lastName', option.last_name);
												setIsserchClick(true);
												setResults([]);
											}}
										>
											{option.label}
										</li>
									))}
								</ul>
							)}
							{formik.submitCount > 0 && formik.errors.firstName && (
								<div className='text-danger'>{formik.errors.firstName}</div>
							)}
						</div>
						<div className='mt-6'>
							<label
								className='form-label'
								htmlFor='lastName'
							>
								{constant?.lastName}
							</label>
							<FormControl
								value={formik.values.lastName}
								onChange={handleSearchChange}
								name='lastName'
								placeholder=''
								autoComplete='off'
							/>
							{options1.length > 0 && (
								<ul className='w-full bg-light p-3 list-unstyled'>
									{options1.map((option, index) => (
										<li
											key={index}
											className='cursor-pointer'
											onClick={() => {
												formik.setFieldValue('firstName', option.first_name);
												formik.setFieldValue('lastName', option.last_name);
												setIsserchClick(true);
												setResults([]);
											}}
										>
											{option.label}
										</li>
									))}
								</ul>
							)}
							{formik.submitCount > 0 && formik.errors.lastName && (
								<div className='text-danger'>{formik.errors.lastName}</div>
							)}
						</div>
						<div className='px-2 text-center'>
							<Button
								variant='secondary'
								size='lg'
								className='w-full mt-10 mb-3'
								type='submit'
								disabled={isDisabled}
							>
								{modal?.addWelcomeParticipantButtonText}
							</Button>
							<NavLink
								to={'/'}
								className='text-center welcome-text-decoration'
							>
								{table?.facilitatorLogin}
							</NavLink>
						</div>
					</form>
					{errorMsg &&
						(isTrue ? (
							<div className='text-danger text-center w-100'>
								{`This session is full.`}
								<br />
								{`Please ask the facilitator for assistance.`}
							</div>
						) : (
							<div className='text-danger text-center'>{errorMsg}</div>
						))}
				</Modal.Body>
			</Modal>
		</>
	);
}
export default WelcomeParticipants;
